module.exports = __webpack_public_path__ + "static/media/sprite.b559c5aa.svg";